$(".main_menu>nav>ul>li").hover(function () {
  var mega_Menu_Height = $(".shop-category>li").find(".shop-mega-menu").height();
  var containerHeight = $(".shop-category>li").parents(".shop-category-contain").height();
  if (mega_Menu_Height > containerHeight) {
      $(".shop-category>li").parents(".shop-category-contain").height(mega_Menu_Height);
  } else {
      $(".shop-category>li").parents(".shop-category-contain").height(containerHeight);
  }
});

$(".shop-category>li").hover(function () {
  $(".shop-category>li.active").removeClass("active");
  $(".shop-mega-menu.hover").removeClass("hover");
  $(this).parents(".shop-category-contain").attr("style", "");
  $(this).addClass("active");
  $(this).find(".shop-mega-menu").addClass("hover");
  var mega_Menu_Height = $(".shop-category>li.active").find(".shop-mega-menu.hover").height();
  var containerHeight = $(this).parents(".shop-category-contain").height();

  if (mega_Menu_Height > containerHeight) {
      $(this).parents(".shop-category-contain").height(mega_Menu_Height);
      $(this).find(".shop-menu > ul").height(mega_Menu_Height);
  } else {
      $(this).parents(".shop-category-contain").height(containerHeight);
      $(this).find(".shop-menu > ul").height(containerHeight);
  }
});

$(window).load(function () {
  var mega_Menu_Height = $(".shop-category>li.active").find(".shop-mega-menu.hover").height();
  var containerHeight = $(".shop-category>li").parents(".shop-category-contain").height();
  if (mega_Menu_Height > containerHeight) {
      $(".shop-category>li").parents(".shop-category-contain").height(mega_Menu_Height);
  } else {
      $(".shop-category>li").parents(".shop-category-contain").height(containerHeight);
  }
});

// Open and Close Search Bar Toggle
const searchBlock = document.querySelector(".search-block");
const searchToggle = document.querySelector(".search-toggle");
const searchCancel = document.querySelector(".search-cancel");

if (searchToggle && searchCancel) {
   searchToggle.addEventListener("click", () => {
      searchBlock.classList.add("is-active");
   });

   searchCancel.addEventListener("click", () => {
      searchBlock.classList.remove("is-active");
   });
}

/* Sidebar */

  $(document).ready(function () {
    $("#sidebarCollapse").on("click", function () {
      $("#sidebar").addClass("active");
      $(".overlay").addClass("visible");
    });

    $("#sidebarCollapseX").on("click", function () {
      $(".overlay").removeClass("visible");
      $("#sidebar").removeClass("active");
    });

    $(".overlay").on("click", function () {
      $("#sidebar").removeClass("active");
      $(".overlay").removeClass("visible");
    });
  });

$(document).ready(function () {
    $("#add-color").click(function () {
        let colorIndex = $(".color-picker-box").length; // Get current count
        const colorPickerBox = $("<div>").addClass("color-picker-box");

        // Create color input with a proper name
        const colorInput = $("<input>").attr({
            type: "color",
            name: `color_theme[${colorIndex}]`, // Dynamically name inputs
            class: "color-input"
        });

        // Create delete button (X)
        const deleteBtn = $("<button>").text("×").addClass("delete-btn");

        // Remove color picker on click
        deleteBtn.click(function () {
            colorPickerBox.remove();
            updateColorNames(); // Re-index color inputs
        });

        // Append elements
        colorPickerBox.append(colorInput, deleteBtn);
        colorPickerBox.insertBefore("#add-color");
    });

    function updateColorNames() {
        $(".color-picker-box input.color-input").each(function (index) {
            $(this).attr("name", `color_theme[${index}]`); // Re-index after deletion
        });
    }
});
/* product quantity */

$("#decrement").click(function () {
  let currentQuantity = parseInt($("#quantity").val());
  if (currentQuantity > parseInt($("#quantity").attr("min"))) {
    $("#quantity").val(currentQuantity - 1);
  }
});

$("#increment").click(function () {
  let currentQuantity = parseInt($("#quantity").val());
  $("#quantity").val(currentQuantity + 1);
});


$(document).ready(function () {
  $(".zoom")
    .on("mousemove", function (e) {
      const zoomer = $(this);
      const rect = zoomer[0].getBoundingClientRect();
      const offsetX = e.pageX - rect.left;
      const offsetY = e.pageY - rect.top;
      const x = (offsetX / zoomer.width()) * 100;
      const y = (offsetY / zoomer.height()) * 100;

      zoomer.find("img").css({
        "transform-origin": `${x}% ${y}%`,
        transform: "scale(2)",
      });
    })
    .on("mouseleave", function () {
      $(this).find("img").css({
        transform: "scale(1)",
      });
    });
  });


/* cart product quantity */

$(".cart-section").on("click", ".decrement", function () {
  let $cartCard = $(this).closest(".cart-card");
  let $quantity = $cartCard.find(".quantity");
  let currentQuantity = parseInt($quantity.text());
  let minQuantity = 1;

  if (currentQuantity > minQuantity) {
    currentQuantity--;
    $quantity.text(currentQuantity);
    updateTotal($cartCard, currentQuantity);
    updateOverallTotal();
  }
});

$(".cart-section").on("click", ".increment", function () {
  let $cartCard = $(this).closest(".cart-card");
  let $quantity = $cartCard.find(".quantity");
  let currentQuantity = parseInt($quantity.text());

  currentQuantity++;
  $quantity.text(currentQuantity);
  updateTotal($cartCard, currentQuantity);
  updateOverallTotal();
});

function updateTotal($cartCard, quantity) {
  let priceText = $cartCard.find(".price").text();
  let price = parseFloat(priceText.replace("£", ""));
  let total = price * quantity;

  $cartCard.find(".total").text("£" + total.toFixed(2));
}

function updateOverallTotal() {
  let overallTotal = 0;

  $(".cart-section .cart-card").each(function () {
    let totalText = $(this).find(".total").text();
    let total = parseFloat(totalText.replace("£", "").replace(",", ""));
    if (!isNaN(total)) {
      overallTotal += total;
    }
  });

  $(".total-price").text("£" + overallTotal.toFixed(2));
}

// Initial calculation of overall total
updateOverallTotal();

// Toggle for account details password
$("#toggle-password").on("click", function () {
  let passwordInput = $("#change-password");
  let icon = $(this);

  if (passwordInput.attr("type") === "password") {
    passwordInput.attr("type", "text");
    icon.removeClass("bx-hide").addClass("bx-show");
  } else {
    passwordInput.attr("type", "password");
    icon.removeClass("bx-show").addClass("bx-hide");
  }
});

$(document).ready(function () {
    // Select the button and input element
    const $copyBtn = $('#copyLinkBtn');
    const $input = $('.URL');
    const $field = $('.field');

    // Add event listener for the copy button
    $copyBtn.on('click', function () {
        $input.select();
        document.execCommand("copy");

        $field.addClass("active");
        $copyBtn.html("<i class='bx bxs-check-circle fs-3'></i>");

        setTimeout(() => {
            window.getSelection().removeAllRanges();
            $field.removeClass("active");
            $copyBtn.html("<i class='bx bxs-copy fs-3'></i>");
        }, 3000);
    });
});

$(document).ready(function () {
  $("#sign-up-btn").on("click", function (event) {
    event.preventDefault();
    $(".member.container").addClass("sign-up-mode");
    history.pushState(null, null, "/register");
  });

  $("#sign-in-btn").on("click", function (event) {
    event.preventDefault();
    $(".member.container").removeClass("sign-up-mode");
    history.pushState(null, null, "/login");
  });
});

$(document).ready(function() {
    $('.otp-input input').on('input', function() {
        const $inputField = $(this);

        if ($inputField.val().length >= 1) {
            const $nextField = $inputField.next('input');
            if ($nextField.length) {
                $nextField.focus();
            }
        }
    });
});
// Show the loader when the page starts loading
window.addEventListener('beforeunload', () => {
  document.getElementById('global-loader').style.display = 'flex';
});

// Hide the loader once the page is fully loaded
window.addEventListener('load', () => {
  document.getElementById('global-loader').style.display = 'none';
});    


document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.about_auction-container').forEach(container => {
      const content = container.querySelector('.about_auction p');
      const btn = container.querySelector('.read-more-btn');

      if (content && content.scrollHeight > content.clientHeight + 10) {
          btn.style.display = 'inline-block';
      }
  });
});

$(document).ready(function() {
  $('.auction-image').on('click', function() {
      const imgUrl = $(this).data('full');
      const overlay = $('#imageOverlay');
      const overlayImg = $('#overlayImage');
      const downloadBtn = $('#downloadBtn');

      // Set the overlay image and download link
      overlayImg.attr('src', imgUrl);
      downloadBtn.attr('href', imgUrl);

      // Show the overlay
      overlay.show();
  });

  // Close the overlay when clicking on the background or the close button
  $('#imageOverlay').on('click', function(e) {
      if (e.target === this || $(e.target).hasClass('close-overlay')) {
          closeOverlay();
      }
  });
});

// Close overlay function
function closeOverlay() {
  $('#imageOverlay').hide();
  $('#overlayImage').attr('src', '');
}